import * as React from 'react';
import StaticElementButton from './StaticElementButton';
import Popup from './Popup';
import '../css/popup.sass';

interface MoreOptionsOption {
  text: string;
  value: string;
}

interface MoreOptionsPopupProps {
  options: MoreOptionsOption[];
  modal?: boolean;
  onBlur: Function;
  onSelect: Function;
}

export default function MoreOptionsPopup(props: MoreOptionsPopupProps) {
  return (
    <Popup modal={props.modal} onClose={props.onBlur} position="table-action">
      <div className="moreOptionsPopup">
        {props.options.map((option: MoreOptionsOption, index: number) => (
          <StaticElementButton
            label={option.text}
            id={`opt${index}`}
            name="options"
            type="div"
            key={`opt${option.text}`}
            onClick={() => props.onSelect(option.value)}
          >
            {option.text}
          </StaticElementButton>
        ))}
      </div>
    </Popup>
  );
}
